import { envConfig } from "@/envConfig";
import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";

const client = new ApolloClient({
  link: new HttpLink({
    uri: envConfig.NEXT_PUBLIC_BLOGS_ENDPOINT + "/graphql",
    headers: {
      Authorization: `Bearer ${envConfig.NEXT_PUBLIC_BLOGS_ACCESS_TOKEN}`,
    },
  }),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
    },
    query: {
      fetchPolicy: "no-cache",
    },
  },
});

export default client;
